import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Priser.css';

const Priser: React.FC = () => {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuth();

  const handleGetStarted = () => {
    if (!isAuthenticated) {
      // Not signed in → redirect to sign-in page
      navigate('/logg-inn');
    } else if (user?.role === 'organizer' || user?.role === 'admin') {
      // Signed in as organizer → redirect to create event page
      navigate('/arrangor/opprett');
    } else {
      // Signed in but not an organizer → redirect to become organizer form
      navigate('/deltaker/bli-arrangor');
    }
  };
  return (
    <div className="priser-page">
      <div className="priser-container">
        <h1>Priser</h1>
        
        <p className="intro-text">
          Sykkelfest er utviklet for arrangører som ønsker å skape en profesjonell, sosial og minneverdig opplevelse – uten manuelt arbeid og komplisert logistikk.
        </p>

        <div className="highlight-box">
          <p className="highlight-main">Deltakere betaler ingenting.</p>
          <p className="highlight-sub">Kun arrangør betaler for arrangementet.</p>
        </div>

        {/* MVP: Prices hidden during initial launch */}
        <section className="pricing-section">
          <h2>Arrangement – standard</h2>
        {/* 
          <p className="price-range">Fra 1 500 til 3 000 kr per sykkelfest</p>
         */}  
          <div className="suitable-for">
            <h3>Dette passer for:</h3>
            <ul>
              <li>Private initiativ</li>
              <li>Frivillige arrangører</li>
              <li>Mindre arrangementer</li>
              <li>Første gang du arrangerer Sykkelfest</li>
            </ul>
          </div>

          <div className="included">
            <h3>Inkludert:</h3>
            <ul>
              <li>Opprettelse av ett komplett Sykkelfest-arrangement</li>
              <li>Påmelding av deltakere i par</li>
              <li>Automatisk rute- og gruppefordeling</li>
              <li>Optimaliserte sykkelavstander</li>
              <li>Varsler og veiledning til deltakerne underveis</li>
              <li>Felles sluttlokasjon / etterfest</li>
              <li>Oversikt etter arrangementet (hvem møtte hvem)</li>
              <li>Standard Sykkelfest-design</li>
            </ul>
          </div>

          <p className="no-binding">
            Ingen binding. Ingen deltakeravgift. Ingen skjulte kostnader.
          </p>
        </section>

        <section className="pricing-section white-label">
          <h2>Arrangement med tilpasset profil (white-label)</h2>
          {/* 
          <p className="price-range">Tillegg: 1 000 – 2 000 kr per arrangement</p>
          */}
          <p className="description">
            For profesjonelle arrangører som ønsker en tydelig og helhetlig profil.
          </p>

          <div className="included">
            <h3>Inkluderer:</h3>
            <ul>
              <li>Egen logo</li>
              <li>Egendefinerte farger (primær og sekundær)</li>
              <li>Arrangørnavn synlig i hele løsningen</li>
              <li>Tilpasset landingsside og deltakersider</li>
              <li>Profesjonelt uttrykk som matcher din virksomhet</li>
            </ul>
          </div>

          <div className="suitable-for">
            <h3>Perfekt for:</h3>
            <ul>
              <li>Puber og barer</li>
              <li>Restauranter</li>
              <li>Eventbyråer</li>
              <li>Bedrifter og teambuilding</li>
              <li>Kommunale arrangementer</li>
            </ul>
          </div>
        </section>

        {/* <section className="pricing-table">
          <h2>Totalkostnad – eksempel</h2>
          <table>
            <thead>
              <tr>
                <th>Type arrangement</th>
                <th>Pris</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Standard Sykkelfest</td>
                <td>1 500 – 3 000 kr</td>
              </tr>
              <tr>
                <td>Sykkelfest med egen profil</td>
                <td>2 500 – 5 000 kr</td>
              </tr>
            </tbody>
          </table>
          <p className="table-note">Alle priser er per arrangement.</p>
        </section>
        */}

        <section className="why-section">
          <h2>Hvorfor betaler arrangøren – og ikke deltakerne?</h2>
          <p>Sykkelfest er designet for lav terskel og høy deltakelse.</p>
          
          <ul>
            <li>Deltakerne bidrar allerede ved å være vertskap og delta aktivt</li>
            <li>Ingen betaling gir høyere påmelding og bedre stemning</li>
            <li>Arrangøren samler glade mennesker til en livlig etterfest på sitt sted</li>
            <li>Arrangøren får full kontroll, mindre administrasjon og et profesjonelt resultat</li>
            <li>Arrangøren får en unik kode/URL per sykkelfest og velger selv hvordan invitasjonen deles – for eksempel som en del av en betalt sluttfest eller annet arrangement</li>
          </ul>

          <div className="you-pay-for">
            <h3>Arrangøren betaler for:</h3>
            <ul>
              <li>Teknologi</li>
              <li>Logistikk</li>
              <li>Struktur</li>
              <li>Tidsbesparelse</li>
              <li>Kvalitet og forutsigbarhet</li>
            </ul>
          </div>
        </section>

        <section className="startup-phase">
          <h2>Ingen betalingsløsning i oppstartsfasen</h2>
          <p>I oppstartsfasen:</p>
          <ul>
            <li>Avtales pris direkte mellom systemeier og hver enkelt arrangør</li>
            <li>Fakturering eller pilotavtale</li>
            <li>Ingen kortbetaling eller deltakerbetaling</li>
          </ul>
          <p>Dette gir fleksibilitet og rask oppstart.</p>
        </section>

        <section className="support-section">
          <h2>Støtt utviklingen av Sykkelfest</h2>
          <p>
            Sykkelfest er utviklet som en hobby og lidenskap for å skape gode sosiale opplevelser. 
            Om du som deltaker har hatt en flott opplevelse og ønsker å støtte videreutvikling av løsningen, 
            setter jeg stor pris på det!
          </p>
          <div className="buymeacoffee-box">
            <a 
              href="https://buymeacoffee.com/simonskothn" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <img 
                src="/bmc-button.png" 
                alt="Buy Me a Coffee" 
                style={{ maxWidth: '320px', width: '100%', height: 'auto' }}
              />
            </a>
          </div>
          <p className="support-note">
            All støtte går til hosting, vedlikehold og nye funksjoner som kommer alle til gode.
          </p>
        </section>

        <section className="cta-section">
          <h2>Klar for å arrangere Sykkelfest?</h2>
          <button onClick={handleGetStarted} className="btn btn-primary btn-large">Kom i gang</button>
        </section>
      </div>
    </div>
  );
};

export default Priser;
